import { ViewConfig } from "@lib/views";
import { ChartOfAccountsColumn } from "@common/types/views/chartOfAccountsView";
import { ChartOfAccountsRow } from "./utils";
import { AccountNameCell } from "./Cells/AccountNameCell";
import { AccountTypeCell } from "./Cells/AccountTypeCell";
import { AccountSubtypeCell } from "./Cells/AccountSubtypeCell";
import { DebitCell } from "./Cells/DebitCell";
import { CreditCell } from "./Cells/CreditCell";
import { BalanceCell } from "./Cells/BalanceCell";
import { SourceCell } from "./Cells/SourceCell";
import { Form1099BoxCell } from "./Cells/Form1099BoxCell";
import { EntitiesCell } from "./Cells/EntitiesCell";
import { ActionsCell } from "./Cells/ActionsCell";

export const createChartOfAccountsViewConfig = (): ViewConfig<
    ChartOfAccountsRow,
    ChartOfAccountsColumn,
    never
> => ({
    columns: {
        [ChartOfAccountsColumn.NAME]: {
            accessorKey: "classification",
            name: "Account",
            header: "Account",
            immutable: true,
            cell: AccountNameCell,
            minSize: 300,
            maxSize: 800,
        },
        [ChartOfAccountsColumn.TYPE]: {
            accessorKey: "account.type",
            name: "Type",
            header: "Type",
            cell: AccountTypeCell,
            minSize: 150,
            maxSize: 240,
        },
        [ChartOfAccountsColumn.SUBTYPE]: {
            accessorKey: "account.subtype",
            name: "Subtype",
            header: "Subtype",
            cell: AccountSubtypeCell,
            minSize: 150,
            maxSize: 400,
        },
        [ChartOfAccountsColumn.DEBIT]: {
            accessorKey: "account.debit",
            name: "Debit",
            header: "Debit",
            cell: DebitCell,
            minSize: 120,
            maxSize: 150,
        },
        [ChartOfAccountsColumn.CREDIT]: {
            accessorKey: "account.credit",
            name: "Credit",
            header: "Credit",
            cell: CreditCell,
            minSize: 120,
            maxSize: 150,
        },
        [ChartOfAccountsColumn.BALANCE]: {
            accessorKey: "account.balance",
            name: "Balance",
            header: "Balance",
            cell: BalanceCell,
            minSize: 120,
            maxSize: 150,
        },
        [ChartOfAccountsColumn.SOURCE]: {
            accessorKey: "account.isManuallyCreated",
            name: "Source",
            header: "Source",
            cell: SourceCell,
            minSize: 100,
            maxSize: 160,
        },
        [ChartOfAccountsColumn.FORM_1099_BOX]: {
            accessorKey: "account.form1099Box",
            name: "1099 box",
            header: "1099 box",
            cell: Form1099BoxCell,
            minSize: 220,
            maxSize: 380,
        },
        [ChartOfAccountsColumn.ENTITIES]: {
            accessorKey: "entityIds",
            name: "Entities",
            header: "Entities",
            cell: EntitiesCell,
            minSize: 100,
            maxSize: 100,
        },
        [ChartOfAccountsColumn.ACTIONS]: {
            accessorKey: "actions",
            name: "Actions",
            header: "",
            immutable: true,
            cell: ActionsCell,
            minSize: 100,
            maxSize: 100,
            hiddenFromSettings: true,
        },
        // Preview-only column. Declared here only to satisfy the total column
        // record; the live CoA never renders it because it is absent from the
        // live default view's columns (`internal` additionally hides it from
        // column settings). The apply-template preview overrides this entry
        // with the real cell.
        [ChartOfAccountsColumn.ORIGIN]: {
            accessorKey: "account.id",
            name: "Origin",
            header: "Origin",
            internal: true,
            minSize: 180,
            maxSize: 320,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: ChartOfAccountsColumn.NAME,
        childrenKey: "accounts",
    },
});
